export default "__VITE_ASSET__DcTe3_Fs__"